// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2de1481f","455":"d141873a","977":"1deedf01"}[chunkId] + ".chunk.js";
};